import React from 'react';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { SideSheet } from '@gerdau/hefesto-mais-web';
import { Button, TextField } from '@gerdau/hefesto';

import {
  Container,
  Content,
  Footer,
  FooterButtons,
  SideSheetContainer,
  Subtitle
} from './styles';

import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import {
  OrderCancelConfirm,
  OrderCancelFinished,
  UpateItemsUnavailable
} from '../ModalsOrder';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';

export const OrderCancel = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const hasCancel = params.has('cancel');
  const notallowed = params.get('cancel') === 'notallowed';
  const withoutItems = params.get('type') === 'withoutitems';
  const finished = params.get('cancel') === 'finished';

  const updateItemsState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders.updateItems
  );

  if (!updateItemsState || !updateItemsState.itemsAllowed) {
    return null;
  }
  const [cancelCause, setCancelCause] = React.useState('');

  const dispatch = useDispatch();
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const handleClose = () => {
    updateQueryParam('cancel');
  };

  const handleConfirm = () => {
    updateQueryParam('cancel');
    updateQueryParam('cancel', 'pending');

    dispatch(
      sendTagging({
        event: 'solicitar_cancelamento',
        message: cancelCause,
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  if (withoutItems || notallowed) {
    return (
      <UpateItemsUnavailable
        items={updateItemsState.itemsSelected.filter(
          (item) => !item.changeAllowed
        )}
        itemsAllowedLength={updateItemsState.itemsAllowed.length}
        type="cancel"
      />
    );
  }

  if (finished) {
    return <OrderCancelFinished />;
  }

  return (
    <Container>
      <OrderCancelConfirm
        items={updateItemsState.itemsAllowed}
        cancelMessage={cancelCause}
      />
      <SideSheet
        title={`Solicitar o cancelamento de ${
          updateItemsState.itemsAllowed.length
        } ite${updateItemsState.itemsAllowed.length > 1 ? 'ns' : 'm'}`}
        openFromSide="right"
        onClose={handleClose}
        isOpen={hasCancel}
      >
        <SideSheetContainer>
          <Subtitle>
            Sua solicitação de cancelamento será analisada e respondida em até 3
            dias úteis. Deseja solicitar o cancelamento dos itens abaixo?
          </Subtitle>

          <Content>
            {updateItemsState.itemsAllowed.map((item) => (
              <span key={`${item.salesOrder}-${item.salesOrderItem}`}>
                {item.materialDescription}
              </span>
            ))}
          </Content>

          <Footer>
            <TextField
              label="Motivo do cancelamento"
              name="motivo"
              placeholder="Digite o motivo do cancelamento"
              type={'text'}
              iconPosition={'left'}
              value={cancelCause}
              onChange={(e) => setCancelCause(e.target.value)}
              maxLength={256}
            />
            <FooterButtons>
              <Button
                variant="secondary"
                name="btn-back-sidesheet"
                onClick={handleClose}
              >
                Fechar
              </Button>
              <Button
                variant="danger"
                name="btn-cancel-sidesheet"
                onClick={handleConfirm}
              >
                Solicitar cancelamento
              </Button>
            </FooterButtons>
          </Footer>
        </SideSheetContainer>

        <OrderCancelConfirm
          items={updateItemsState.itemsAllowed}
          cancelMessage={cancelCause}
        />
      </SideSheet>
    </Container>
  );
};
